(() => {
  var PDPUpsellWrapperApp = (() => {
    function isIOS() {
      // Direct UA match for iPhone/iPod
      if (/iPhone|iPod/i.test(navigator.userAgent)) return true;

      // iPadOS 13+ spoofs Mac UA — distinguish from real Mac via pointer type
      if (/Mac/i.test(navigator.userAgent) && navigator.maxTouchPoints > 1) {
        return window.matchMedia('(pointer: coarse)').matches;
      }

      return false;
    }

    var toggleUpsell = (element) => {
      const productForms = document.querySelectorAll('.product-form form');
      const atcButtons = document.querySelectorAll(
        '.product-form form button[type="submit"]'
      );

      if (!element) return;

      if (element.classList.contains('active')) {
        element.classList.remove('active');

        atcButtons.forEach((atcButton) => {
          atcButton.innerText = 'Add to cart';
        });

        productForms.forEach((productForm) => {
          productForm
            .querySelectorAll('[js-upsell-product-input]')
            .forEach((input) => {
              input.remove();
            });

          productForm
            .querySelectorAll('[js-manual-more-payment]')
            .forEach((manualMorePayment) => {
              manualMorePayment.classList.add('d-none');

              const morePaymentHref = '';

              manualMorePayment.setAttribute('href', morePaymentHref);
            });
        });
      } else {
        element.classList.add('active');

        atcButtons.forEach((atcButton) => {
          atcButton.innerText = 'Add both to cart';
        });

        productForms.forEach((productForm) => {
          const upsellInputs = `
            <input
              type="hidden"
              name="items[0][id]"
              value="${element.getAttribute('data-upsell-variant-id')}"
              js-upsell-product-input
            >

            <input
              type="hidden"
              name="items[0][quantity]"
              value="1"
              js-upsell-product-input
            >

            <input
              type="hidden"
              name="items[0][properties][_upsell_source]"
              value="PDP Upsell"
              js-upsell-product-input
            >
          `;

          productForm.insertAdjacentHTML('beforeend', upsellInputs);

          productForm
            .querySelectorAll('[js-manual-more-payment]')
            .forEach((manualMorePayment) => {
              if (
                manualMorePayment.classList.contains('apple') &&
                !isIOS()
              ) {
                return;
              }

              manualMorePayment.classList.remove('d-none');

              const idInput = productForm.querySelector('input[name="id"]');

              if (!idInput) return;

              let quantity = 1;

              const quantityInput = productForm.querySelector(
                'input[name="quantity"]'
              );

              if (quantityInput) {
                quantity = quantityInput.value;
              }

              const morePaymentHref =
                `/cart/${idInput.value}:${quantity},` +
                `${element.getAttribute('data-upsell-variant-id')}:1?checkout`;

              manualMorePayment.setAttribute('href', morePaymentHref);
            });
        });
      }
    };

    var updateElement = (variantId) => {
      if (!variantId || variantId === '') return;

      const productSection = document.querySelector('.single-product');

      if (!productSection) return;

      const sectionId = productSection.getAttribute('data-section');

      fetch(
        `${window.location.pathname}?variant=${variantId}&section_id=${sectionId}`
      )
        .then((response) => response.text())
        .then((html) => {
          const parser = new DOMParser();

          const documentFromResponse = parser.parseFromString(
            html,
            'text/html'
          );

          const newElement = documentFromResponse.querySelector(
            '.product-info--upsell-product'
          );

          const currentElement = document.querySelector(
            '.product-info--upsell-product'
          );

          if (newElement && currentElement) {
            currentElement.innerHTML = newElement.innerHTML;
          }

          document
            .querySelectorAll('[js-upsell-product-input]')
            .forEach((element) => {
              element.remove();
            });
        })
        .catch((error) => {
          console.error('Upsell update failed:', error);
        });
    };

    var initialize = () => {
      document.addEventListener('click', (event) => {
        const upsellWrapper = event.target.closest(
          '[js-pdp-upsell-wrapper]'
        );

        if (!upsellWrapper) return;

        toggleUpsell(upsellWrapper);
      });

      document.addEventListener('variant:changed', (event) => {
        if (!event.detail || !event.detail.id) return;

        updateElement(event.detail.id);
      });
    };

    return {
      init: initialize
    };
  })();

  var ShippingCountdownApp = (() => {
    var intervalId = null;

    var getEndTime = () => {
      const now = new Date();

      return new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate(),
        15,
        0,
        0,
        0
      );
    };

    var formatRemaining = (milliseconds) => {
      if (milliseconds <= 0) return null;

      const totalSeconds = Math.floor(milliseconds / 1000);
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);

      return `${hours}h ${String(minutes).padStart(2, '0')}m`;
    };

    var isWeekend = () => {
      const day = new Date().getDay();

      return day === 0 || day === 6;
    };

    var updateCountdowns = () => {
      const now = new Date();
      const remaining = getEndTime() - now;

      document
        .querySelectorAll('[js-shipping-countdown]')
        .forEach((widget) => {
          const textElement = widget.querySelector('[data-template]');

          if (!textElement) return;

          if (isWeekend() || remaining <= 0) {
            widget.classList.add('d-none');
            return;
          }

          widget.classList.remove('d-none');

          textElement.innerHTML = textElement
            .getAttribute('data-template')
            .replace(
              '((remain_time_value))',
              formatRemaining(remaining)
            );
        });
    };

    var scheduleNextMidnight = () => {
      const now = new Date();

      const midnight = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate() + 1,
        0,
        0,
        0,
        0
      );

      window.setTimeout(() => {
        window.clearInterval(intervalId);

        updateCountdowns();

        intervalId = window.setInterval(updateCountdowns, 1000);

        scheduleNextMidnight();
      }, midnight - now);
    };

    var initialize = () => {
      updateCountdowns();

      intervalId = window.setInterval(updateCountdowns, 1000);

      scheduleNextMidnight();
    };

    return {
      init: initialize
    };
  })();

  var AdditionalPaymentButtonsApp = (() => {
    var initialize = () => {
      document.addEventListener('click', (event) => {
        const expressCheckout = event.target.closest(
          '[js-express-checkout-options]'
        );

        if (!expressCheckout) return;

        const container = document.querySelector(
          '[js-additional-payment-buttons]'
        );

        if (!container) return;

        container.style.maxHeight = `${container.scrollHeight}px`;

        expressCheckout.classList.add('d-none');
      });
    };

    return {
      init: initialize
    };
  })();

  var CartDrawerUpsellApp = (() => {
    var initialize = () => {
      document.addEventListener('click', async (event) => {
        const button = event.target.closest('[js-upsell-atc]');

        if (!button) return;

        const variantId = button.dataset.variantId;

        if (!variantId) return;

        button.classList.add('loading');

        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              id: variantId,
              quantity: 1,
              properties: {
                _upsell_source: 'Drawer Upsell'
              },
              sections: [
                'cart-drawer',
                'cart-icon-bubble'
              ],
              sections_url: window.location.pathname
            })
          });

          const data = await response.json();

          if (!response.ok) {
            console.error('Cart error:', data.description);

            button.classList.remove('loading');

            return;
          }

          const cartDrawer = document.querySelector('cart-drawer');

          if (
            cartDrawer &&
            typeof cartDrawer.renderContents === 'function'
          ) {
            cartDrawer.renderContents(data);
          }
        } catch (error) {
          console.error('Fetch error:', error);

          button.classList.remove('loading');
        }
      });
    };

    return {
      init: initialize
    };
  })();

  var ProductThumbnailCarouselFixApp = (() => {
    var refreshTimers = [];

    function clearRefreshTimers() {
        refreshTimers.forEach((timer) => {
        window.clearTimeout(timer);
        });

        refreshTimers = [];
    }

    function getEventVariantId(event) {
        if (event?.detail?.id) {
        return String(event.detail.id);
        }

        if (event?.detail?.variant?.id) {
        return String(event.detail.variant.id);
        }

        return null;
    }

    function getInitialVariantId() {
        const urlVariant = new URL(
        window.location.href
        ).searchParams.get('variant');

        if (urlVariant) {
        return String(urlVariant);
        }

        const visibleGallery = document.querySelector(
        'media-gallery:not([hidden])'
        );

        const productSection =
        visibleGallery?.closest('.single-product');

        const variantInput =
        productSection?.querySelector(
            'input[name="id"]'
        );

        return variantInput?.value
        ? String(variantInput.value)
        : null;
    }

    function refreshThumbnailCarousel(variantId) {
        const $ = window.jQuery || window.$;

        if (!$ || !$.fn || !$.fn.slick) return;
        if (!variantId) return;

        const $gallery = $('media-gallery:visible').first();

        if (!$gallery.length) return;

        const $thumbnailWrapper = $gallery
        .find('[id^="GalleryThumbnails"]')
        .first();

        if (!$thumbnailWrapper.length) return;

        const $carousels = $thumbnailWrapper.find(
        'ul.slick-initialized'
        );

        if (!$carousels.length) return;

        let $activeCarousel = $carousels
        .filter(function () {
            return (
            String($(this).attr('data-id')) ===
            String(variantId)
            );
        })
        .first();

        console.log(
        'Selected variant:',
        variantId,
        'Matching carousel:',
        $activeCarousel.length
        );

        if (!$activeCarousel.length) {
        console.warn(
            'No thumbnail carousel found for variant:',
            variantId
        );

        return;
        }

        // Hide all thumbnail sets
        $carousels.css({
        display: 'none',
        visibility: 'hidden',
        opacity: '0'
        });

        // Show only the selected variant's thumbnails
        $thumbnailWrapper.css({
        display: 'block',
        visibility: 'visible',
        opacity: '1'
        });

        $activeCarousel.css({
        display: 'block',
        visibility: 'visible',
        opacity: '1',
        width: '100%'
        });

        $activeCarousel
        .find('.slick-list, .slick-track')
        .css({
            visibility: 'visible',
            opacity: '1'
        });

        try {
        $activeCarousel.slick('setPosition');
        } catch (error) {
        console.warn(
            'Thumbnail carousel update failed:',
            error
        );
        }
    }

    function runRefreshSequence(event) {
        clearRefreshTimers();

        /*
        * Keep the variant ID from the event.
        * Do not replace it with a hidden input value later.
        */
        const variantId =
        getEventVariantId(event) ||
        getInitialVariantId();

        if (!variantId) return;

        [50, 150, 300, 600, 1000].forEach(
        (delay) => {
            const timer = window.setTimeout(() => {
            refreshThumbnailCarousel(variantId);
            }, delay);

            refreshTimers.push(timer);
        }
        );
    }

    function initialize() {
        document.addEventListener(
        'variant:changed',
        runRefreshSequence
        );

        document.addEventListener(
        'variant:change',
        runRefreshSequence
        );

        window.addEventListener('resize', () => {
        window.setTimeout(() => {
            refreshThumbnailCarousel(
            getInitialVariantId()
            );
        }, 100);
        });

        window.setTimeout(() => {
        refreshThumbnailCarousel(
            getInitialVariantId()
        );
        }, 300);
    }

    return {
        init: initialize
    };
    })();


  var CarouselScrollLockApp = (() => {
    // Prefer vertical page scroll unless the gesture is clearly horizontal.
    var AXIS_RATIO = 1.75;
    var MIN_DISTANCE = 12;

    function bindOwlCarousel(root) {
      if (root.dataset.scrollLockBound === 'true') return;
      root.dataset.scrollLockBound = 'true';

      var startX = 0;
      var startY = 0;
      var axis = '';

      root.addEventListener(
        'touchstart',
        function (event) {
          if (event.touches.length !== 1) return;
          startX = event.touches[0].clientX;
          startY = event.touches[0].clientY;
          axis = '';
        },
        { capture: true, passive: true }
      );

      root.addEventListener(
        'touchmove',
        function (event) {
          if (event.touches.length !== 1) return;

          if (!axis) {
            var dx = Math.abs(event.touches[0].clientX - startX);
            var dy = Math.abs(event.touches[0].clientY - startY);
            if (dx < MIN_DISTANCE && dy < MIN_DISTANCE) return;
            // Require a clearly horizontal swipe before Owl can claim the gesture.
            axis = dx > dy * AXIS_RATIO ? 'h' : 'v';
          }

          if (axis === 'v') {
            // Stop Owl (and similar handlers) from preventDefault-ing vertical scroll.
            event.stopPropagation();
          }
        },
        { capture: true, passive: true }
      );
    }

    function bindOverflowScroller(root) {
      if (root.dataset.scrollLockBound === 'true') return;
      root.dataset.scrollLockBound = 'true';

      var startX = 0;
      var startY = 0;
      var axis = '';
      var previousOverflowX = '';

      root.addEventListener(
        'touchstart',
        function (event) {
          if (event.touches.length !== 1) return;
          startX = event.touches[0].clientX;
          startY = event.touches[0].clientY;
          axis = '';
          previousOverflowX = root.style.overflowX;
        },
        { passive: true }
      );

      root.addEventListener(
        'touchmove',
        function (event) {
          if (event.touches.length !== 1) return;

          if (!axis) {
            var dx = Math.abs(event.touches[0].clientX - startX);
            var dy = Math.abs(event.touches[0].clientY - startY);
            if (dx < MIN_DISTANCE && dy < MIN_DISTANCE) return;
            axis = dx > dy * AXIS_RATIO ? 'h' : 'v';
            if (axis === 'v') {
              root.style.overflowX = 'hidden';
            }
          }
        },
        { passive: true }
      );

      var reset = function () {
        root.style.overflowX = previousOverflowX || '';
        axis = '';
      };

      root.addEventListener('touchend', reset, { passive: true });
      root.addEventListener('touchcancel', reset, { passive: true });
    }

    function scan() {
      document.querySelectorAll('.owl-carousel').forEach(bindOwlCarousel);
      document
        .querySelectorAll(
          '.ColletionContainer-Wrapper, .slider.slider--everywhere, .slider.slider--mobile'
        )
        .forEach(bindOverflowScroller);
    }

    var initialize = function () {
      scan();
      // Owl inits on document.ready after this file; rescan shortly after.
      window.setTimeout(scan, 500);
      window.setTimeout(scan, 1500);
    };

    return { init: initialize };
  })();


  var MegamenuPromoTrackingApp = (() => {
    var STORAGE_KEY = 'pipetto_megamenu_promo';

    function savePromo(payload) {
      try {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
      } catch (e) {}
    }

    function readPromo() {
      try {
        var raw = sessionStorage.getItem(STORAGE_KEY);
        return raw ? JSON.parse(raw) : null;
      } catch (e) {
        return null;
      }
    }

    function updateCartAttributes(payload) {
      if (!payload) return Promise.resolve();

      return fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        credentials: 'same-origin',
        body: JSON.stringify({
          attributes: {
            'Megamenu menu': payload.menu || '',
            'Megamenu promo': payload.title || '',
            'Megamenu promo id': payload.block || ''
          }
        })
      }).catch(function () {
        // Non-blocking: mm_* URL params + order attributes still apply if this fails.
      });
    }

    function onPromoClick(event) {
      var link = event.target.closest('a[data-megamenu-promo]');
      if (!link) return;

      var payload = {
        menu: link.getAttribute('data-megamenu-menu') || '',
        title: link.getAttribute('data-megamenu-title') || '',
        block: link.getAttribute('data-megamenu-block') || '',
        href: link.href || ''
      };

      savePromo(payload);
      // Fire-and-forget so navigation is not delayed.
      updateCartAttributes(payload);
    }

    var initialize = function () {
      document.addEventListener('click', onPromoClick, true);

      // Re-apply stored promo attributes if cart was emptied/recreated mid-session.
      var stored = readPromo();
      if (stored && (stored.title || stored.menu)) {
        updateCartAttributes(stored);
      }
    };

    return { init: initialize };
  })();

  var App = (() => {
    var initialize = () => {
      PDPUpsellWrapperApp.init();
      ShippingCountdownApp.init();
      AdditionalPaymentButtonsApp.init();
      CartDrawerUpsellApp.init();
      ProductThumbnailCarouselFixApp.init();
      CarouselScrollLockApp.init();
      MegamenuPromoTrackingApp.init();
    };

    return {
      init: initialize
    };
  })();

  document.addEventListener('DOMContentLoaded', () => {
    App.init();
  });
})();